<template>
  <van-image
    @click="goClick"
    lazy-load
    round
    :width="width"
    :height="height"
    :src="myAvatar"
  />
</template>

<script>
export default {
  props: {
    src: {
      type: String
    },
    width: {
      type: String,
      default: "0.8rem"
    },
    height: {
      type: String,
      default: "0.8rem"
    },
    gender: {
      type: Number,
      default: 0
    }
  },
  watch: {
    src: {
      handler(newVal, oldVal) {
        this.getImg();
      }
    }
  },
  data() {
    return {
      imgBoy: window.loadIMG['boy'],
      imgGirl: window.loadIMG['girl'],
      myAvatar: ""
    };
  },
  created() {
    this.getImg();
  },
  methods: {
    goClick() {
      this.$emit("click");
    },
    getImg() {
      if (this.src) {
        this.myAvatar = this.src;
      } else {
        if (this.gender === 0) {
          this.myAvatar = this.imgBoy;
        } else {
          this.myAvatar = this.imgGirl;
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/common/AvatarImg/index.vue